// extracted by mini-css-extract-plugin
export default {"mainWrap":"PageNotFound_mainWrap__9xLZs"};